<template>
  <nav class="site-nav">
    <div class="nav-content">
      <div v-for="item in navItems" :key="item.path" class="nav-item-wrapper">
        <router-link
          v-if="!item.children"
          :to="item.path"
          class="nav-item"
          :class="{ 'nav-item--active': isActiveMenu(item) }"
        >
          {{ item.name }}
        </router-link>
        <div v-else class="nav-item-dropdown">
          <span
            class="nav-item"
            :class="{ 'nav-item--active': isActiveMenu(item) }"
            >{{ item.name }}</span
          >
          <div class="dropdown-content">
            <router-link
              v-for="child in item.children"
              :key="child.path"
              :to="child.path"
              class="dropdown-item"
            >
              {{ child.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "SiteNavigation",
  props: ["id"],
  inject: ["NavList"],
  data() {
    return {};
  },
  computed: {
    navItems() {
      return [
        { name: "首页", path: "/" },
        ...(this.NavList() || []).map((d) => ({
          name: d.name,
          path: `/column/${d.code}`,
          children:
            d.children &&
            d.children.map((c) => ({
              name: c.name,
              path: `/column/${c.code}`,
            })),
        })),
        { name: "联系我们", path: "/contact" },
      ];
    },
  },
  methods: {
    isActiveMenu(item) {
      if (this.id === "home" && item.path === "/") {
        return true;
      }

      return (
        this.id &&
        (item.path.includes(this.id) ||
          item?.children?.find((d) => d.path.includes(this.id)))
      );
    },
  },
  mounted() {
    console.log(this.NavList());
  },
};
</script>

<style lang="scss" scoped>
.site-nav {
  background: #003366;
  position: sticky;
  top: 100px;
  z-index: 5;
  .nav-content {
    width: 1200px;
    margin: 0 auto;
    height: 68px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    flex-wrap: wrap;
    .nav-item-wrapper {
      position: relative;
      height: 100%;

      &:hover {
        .dropdown-content {
          display: block;
        }
      }
    }

    .nav-item {
      font-size: 18px;
      color: #fff;
      text-decoration: none;
      padding: 0 40px;
      height: 68px;
      line-height: 68px;
      display: block;
      &:hover,
      &.nav-item--active {
        background: #1b6b9b;
      }
    }

    .nav-item-dropdown {
      height: 100%;
      cursor: pointer;
      position: relative;
      &:hover {
        .nav-item {
          background: #1b6b9b;
        }
      }
      .dropdown-content {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        background: #fff;
        width: 100%;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

        .dropdown-item {
          display: block;
          color: #fff;
          text-decoration: none;
          padding: 15px 20px;
          font-size: 16px;
          color: #222;
          text-align: center;
          &:hover {
            background: #1b6b9b;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
